module.exports = __webpack_public_path__ + "img/bangladesh.32e1ddfa.svg";